import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var LaptopHouse = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M272 288h-64a16 16 0 0 1-16-16v-64a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v37.12c11.11-12.88 27-21.12 44.8-21.12h136.94l6.65-7.53A16.51 16.51 0 0 0 480 207a16.31 16.31 0 0 0-4.75-10.61L416 144V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v39.3L263.5 8.92C258 4 247.45 0 240.05 0s-17.93 4-23.47 8.92L4.78 196.42A16.15 16.15 0 0 0 0 207a16.4 16.4 0 0 0 3.55 9.39l18.79 21.31A16.22 16.22 0 0 0 33 242.48a16.51 16.51 0 0 0 9.34-3.48L64 219.88V384a32 32 0 0 0 32 32h176zm357.33 160H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91 0-28.8 14.33-28.8 32v160h-37.33A10.67 10.67 0 0 0 256 458.67v10.66A42.82 42.82 0 0 0 298.6 512h298.8a42.82 42.82 0 0 0 42.6-42.67v-10.66A10.67 10.67 0 0 0 629.33 448zM544 448H352V304h192z"
  }));
});
LaptopHouse.displayName = 'LaptopHouse';
export var LaptopHouseDimensions = {
  height: 512,
  width: 640
};